import Nav from './Nav';
import connectTo from './Container';

import './styles.scss';

export default connectTo(Nav);